
define('ldsh!modules/accounts/users/detail/form-user-services-template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if ((typeof group !== 'undefined' && group.activeServiceGroup) && (service.get("id") <= 3 || service.get("id") == 5 || service.get("id") == 6)) { ;
__p += '\n<div class="accounts-service panel panel-default">\n  <fieldset>\n    <legend>\n        <span class=" naranja i18n size13" data-i18n="ACCOUNTS.COMPANIES.LBL_SERVICE_' +
__e(service.get("id") ) +
'"> </span>\n    </legend>\n    ';
 _.each(service.get("companies"), function(company,index) { ;
__p += '\n      ';
 if (index === 0 ) { ;
__p += ' <row> ';
 } ;
__p += '\n      <div class="col-md-4">\n        <div class="md__checkbox--wrapper gap16 mb48 mt24">\n          <input\n            id="' +
__e((service.get('id')+'-'+company.id)) +
'"\n            type="checkbox"\n            class="md__checkbox--primary activateUserservice"\n            data-serviceId="' +
__e(service.get('id')) +
'"\n            name="' +
__e((service.get('id')+'-'+company.id)) +
'"\n            ' +
__e((company.activeServiceCompany && !isnew) ? "checked" : "") +
'\n          />\n          <label\n            class="gap16"\n            for="' +
__e((service.get('id')+'-'+company.id)) +
'"\n          >' +
__e(company.name) +
'</label>\n        </div>\n      </div>\n      ';
 if ((index + 1) % 3 === 0 && index > 0) { ;
__p += ' </row><row> ';
 } ;
__p += '\n    ';
 }); ;
__p += '\n  </fieldset>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

